<div class="flex justify-content-center">
    @if (isLoading) {
        <p-progressSpinner></p-progressSpinner>
    }
</div>

<ng-container>
    @if (!isLoading) {
        @if (!exceptionScheduleObject?.length) {
            <p>No events defined</p>
        } @else {
            <!-- Parent table -->
            <p-table
                class="cbms-generic-table-style"
                [columns]="mainTableCols"
                [value]="exceptionScheduleObject"
                dataKey="id"
                sortField="priority"
                [scrollable]="true"
                [scrollHeight]="'auto'">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th class="button-column"></th>
                        @for (col of columns; track $index) {
                            <th class="cbms-text-align-left">{{col.header}}</th>
                        }
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td class="button-column">
                            <a href="#" [pRowToggler]="rowData">
                                <i (click)="rowData.isExpanded = !rowData.isExpanded" [ngClass]="rowData.isExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                            </a>
                        </td>
                        @for (col of columns; track $index) {
                            <td>{{rowData[col.field]}}</td>
                        }
                    </tr>
                    <!-- sub table -->
                    @if (rowData.isExpanded) {
                        <tr>
                            <td [attr.colspan]="columns.length + 1" style="padding:20px 39px; background-color: white;">

                                    <p><strong>Period:</strong></p>
                                    <p-table [columns]="subTableCols" [value]="rowData.timeValues || []">
                                        <ng-template pTemplate="header" let-columns>
                                            <tr>
                                                @for (col of columns; track $index) {
                                                    <th style="text-align:left">{{col.header}}</th>
                                                }
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                                            <tr>
                                                @for (col of columns; track $index) {
                                                    <td>{{rowData[col.field]}}</td>
                                                }
                                            </tr>
                                        </ng-template>
                                    </p-table>
                            </td>
                        </tr>
                    }
                </ng-template>
            </p-table>
        }
    }
</ng-container>
